import { delay } from 'utils/Delay'

const name = 'DELAY'

export function getDelayAction(time) {
  function execute() {
    return delay(time)
  }

  return {
    name,
    execute,
  }
}
